import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import ThreeDotLoader from "../Loader"


const BulkSelection = () => {
    const [plan, setPlan] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingButtons, setLoadingButtons] = useState({});
    const [message, setMessage] = useState("");
    const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const location = useLocation();
    const navigate = useNavigate();
    const { selectedOrders, wh } = location.state || {};

    useEffect(() => {
        const fetchOrderDetails = async () => {
            try {
                setLoading(true);
                const token = document.cookie.split("=")[1];
                const pinCode = wh?.pinCode || "No Pin Code";

                const response = await axios.post(
                    `${REACT_APP_BACKEND_URL}/bulk/shipBulkOrder`,
                    { selectedOrders, pinCode },
                    {
                        headers: { authorization: `Bearer ${token}` },
                    }
                );
                console.log("bulk", response.data.services)
                setPlan(response.data.services);
            } catch (error) {
                console.error("Error fetching order details:", error);
            } finally {
                setLoading(false);
            }
        };

        if (selectedOrders.length > 0) {
            fetchOrderDetails();
        }
    }, [selectedOrders]);

    const handleBulkShip = async (item) => {
        try {
            const token = document.cookie.split("=")[1];
            setLoadingButtons((prev) => ({ ...prev, [item.name]: true }));
            setMessage("Don't refresh your page...");
            toast.warn("Don't refresh your page..");

            const response = await axios.post(
                `${REACT_APP_BACKEND_URL}/bulk/create-bulk-order`,
                { item, selectedOrders, wh },
                {
                    headers: { authorization: `Bearer ${token}` },
                }
            );

            setMessage(response.data.message);
            toast.success(response.data.message);
            navigate("/dashboard/order");
            setLoadingButtons((prev) => ({ ...prev, [item.name]: "shipped" }));
        } catch (error) {
            console.error("Error creating order:", error);
            setMessage("Failed to create order. Try again.");
            toast.error("Failed to create order. Try again.");
            setLoadingButtons((prev) => ({ ...prev, [item.name]: false }));
        }
    };

    return (
        <div className="flex flex-col justify-center items-center sm:p-4">
            <div className="w-full max-w-5xl sm:bg-white sm:shadow-lg rounded-lg sm:p-6">
                <h2 className="sm:text-[18px] text-[14px] font-[600] text-gray-700 mb-4 sm:text-center">
                    Bulk Selection
                </h2>

                {message && (
                    <div className="mb-4 text-center text-[12px] sm:text-[14px] font-[600] text-red-600">
                        {message}
                    </div>
                )}

                <div className="overflow-x-auto">
                    <table className="w-full border border-gray-300">
                        <thead>
                            <tr className="text-white bg-[#0CBB7D] border border-[#0CBB7D] text-[12px] font-600">
                                <th className="px-3 py-2 text-left">
                                    Courier Partner
                                </th>
                                <th className="px-3 py-2 text-center">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="2" className="text-center py-6">
                                        <ThreeDotLoader />
                                    </td>
                                </tr>
                            ) : plan.length > 0 ? (
                                plan.map((item) => (
                                    <tr key={item._id} className="border hover:bg-gray-50 border-gray-300 text-gray-500 transition-all text-[12px] font-[400] relative">
                                        <td className="border border-gray-300 px-3 py-2 font-[600]">
                                            <h2>
                                                {item.name}
                                            </h2>
                                        </td>
                                        <td className="border border-gray-300 font-[600] px-3 py-2 text-center">
                                            <button
                                                disabled={loadingButtons[item.name]}
                                                className={`px-3 py-2 rounded-lg text-white sm:text-[12px] text-[10px] transition ${loadingButtons[item.name]
                                                        ? "bg-gray-400 cursor-not-allowed"
                                                        : "bg-[#0CBB7D]"
                                                    }`}
                                                onClick={() => handleBulkShip(item)}
                                            >
                                                {loadingButtons[item.name] === "shipped"
                                                    ? "Shipped"
                                                    : loadingButtons[item.name]
                                                        ? "Processing..."
                                                        : "Ship Now"}
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" className="text-center py-4 text-gray-500">
                                        No courier partners available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default BulkSelection;
